import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { book } from '../model/book';
import { BookServiceService } from '../book-service.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { customer } from '../model/customer';
import { UserLoggedInService } from './user-logged-in.service';

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.css']
})
export class UserLoginComponent implements OnInit {
rval=1;
bookList:book[];
error:string;
success:string;
bookform:FormGroup
cust:customer=null
  constructor(private router: Router,private service:BookServiceService,private fb:FormBuilder,private userService:UserLoggedInService) { }

  ngOnInit(): void {
    this.bookList=null
    this.getbook()
    this.createbookForm()
    this.cust=JSON.parse(sessionStorage.getItem("customer"))
    
  }



  createbookForm() {
 
    this.bookform = this.fb.group({
      
      bookName: ['', [Validators.required ]],
     bookYear: ['', [Validators.required ]],
     bookPrice: ['', [Validators.required ]],
      
       branch: ['', [Validators.required ]],
       semester: ['', [Validators.required ]],

    });
  }
  
bookForm(){
this.userService.addBook(this.bookform.value,this.cust.customerId).subscribe(res=>{
  this.success="Book has been successfully added"
  this.getbook()
 
 
},error=>{this.error=error.error.message;


});
}
getbook(){
  this.service.getbook().subscribe(res=>{
   
    this.bookList=res 
    
   
  },error=>{this.error=error.error.message;
  });
  
}
  // logout(){
  //   sessionStorage.clear();
  //   this.router.navigate(['/home']);
  // }
}
